module.exports = __webpack_public_path__ + "img/iphone.05af4048.png";